/* Copyright (c) 2021, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Injectable } from '@angular/core';
import { Logger, LoggingService } from '../logging/logging.service';
import { KbNonPrintableKeyMap } from './hotkeys';

@Injectable({
    providedIn: 'root'
})
export class HotKeyHelper {
    private logger: Logger;

    constructor(loggingService: LoggingService) {
        this.logger = loggingService.getLogger('crimson/hotkeyHelper');
    }

    processKey(key: number): string {
        if (key in KbNonPrintableKeyMap) {
            return KbNonPrintableKeyMap[key];
        }
        const result = String.fromCharCode(key);
        if (result === '') {
            this.logger.error('ERROR: unsupported character: ', key);
        }
        return result;
    }

    shortcutToString(keys: number[]): string {
        if (!keys || keys.length === 0) {
            return KbNonPrintableKeyMap[0];
        }
        return keys.map(key => this.processKey(key)).join('+');
    }
}
